export default __webpack_public_path__ + "static/media/gallery-wip-pommel_04.3e620d8d.jpg";